
import cfr from './cfrList'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

export default{
name:'christmas_form_one',
components: {
cfr,
PopupRadio
},
data(){
return{
showLochiaPicker:false,
showOptions2:false,
options2:['多','中','少'],
showPopupPicker: false,
showOptions1:false,
options1:['脐上？指','脐下？指','完全入盆','平脐','耻骨联合上？指'],
list_id:'',
showCfrList:false,
cfrText:'',
form:{
room:'',
momName:'',
live_time:'',
child_birth:'',
delivery_type:'',
advisory_date:'',
postpartum_days:'',
healing:'',
uterus_place:'',
lochia_amount:'',
lochia_color:'',
lochia_taste:'',
chapped_nipple:'',
breast:'',
milk_amount:'2',
stool:'',
pee:'',
special_case:'',
agent_id:'',
shifts:'',
agent_sign:''
},
showSignature:false,
option:{
penColor:"rgb(0, 0, 0)"
},
get_host:host.host
}
},
created(){
this.apiMemberInfo()
if(this.$route.query.list_id){
this.apiGetCfrList()
}
},
methods:{
GetNumberOfDays(date1,date2){//获得天数

var a1 = Date.parse(new Date(date1));
var a2 = Date.parse(new Date(date2));
var day = parseInt((a2-a1)/ (1000 * 60 * 60 * 24));
return day
},
change_advisory_date(value){
let day = this.GetNumberOfDays(this.form.child_birth,value)+1
this.form.postpartum_days = day
},

onChangeLochiaAmount(val){
this.form.lochia_amount=val
this.$refs.lochiaAmount.focus()
this.showOptions2=false
},

onChange(val){
this.form.uterus_place=val
this.$refs.uterusPlace.focus()
this.showOptions1=false
},

apiGetCfrList(){
let params = {
token: this.$cookie.get('token'),
store_id:this.$cookie.get('store_id'),
}
Api.checkRoomApi.getCheckInfo(params).then ( res => {
console.info("获取查房人列表",res)
if(res.errcode == 1){
this.nurser_name = res.data.nurser_name
this.apiDetail(res.data.nurser_name)
}else{
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},

selectPeople(){
this.showCfrList = true
},

cfrListEven(val,item){
this.showCfrList = val
if(item){
this.form.agent_id = item.id
this.cfrText = item.user_name
}
},

apiMemberInfo(){
let params = {
token: this.$cookie.get('token'),
maternal_info_id: this.$route.query.id
}
Api.checkRoomApi.memberInfo(params).then ( res => {
console.info(res)
if(res.errcode == 1){
this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : ''
this.form.momName = res.data.name
this.form.room = res.data.room_name

this.form.child_birth = this.formatDateTime(res.data.child_birth)
this.form.live_time = this.formatDateTime(res.data.live_time)
}else{
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},

formatDateTime(inputTime) {
var date = new Date(parseInt(inputTime)*1000)
var y = date.getFullYear()
var m = date.getMonth() + 1
m = m < 10 ? ('0' + m) : m;
var d = date.getDate()
d = d < 10 ? ('0' + d) : d
var h = date.getHours()
h = h < 10 ? ('0' + h) : h
var minute = date.getMinutes()
var second = date.getSeconds()
minute = minute < 10 ? ('0' + minute) : minute
second = second < 10 ? ('0' + second) : second
return y + '-' + m + '-' + d
},
save(){
let signature ='signature1'
console.info(this.$refs[signature])
let png = this.$refs[signature].save()
this.form.agent_sign = encodeURI(png)
this.showSignature = true
},
edit(){
this.showSignature = false
this.form.agent_sign = ''
},
clear(){
let signature ='signature1'
let refs = this.$refs[signature].clear()
this.form.agent_sign = ''
},

apiDetail(nurser_name){
let params = {
token: this.$cookie.get('token'),
id:this.$route.query.list_id
}
this.$vux.loading.show({
text: '正在加载'
})
Api.chritmasFormApi.getMatarnalHeathRecord(params).then ( res => {
console.info('请求详情数据')
console.info(res)
if(res.errcode == 200){
let data = res.data
this.form.room = data.room
this.form.delivery_type = data.delivery_type
this.form.postpartum_days=data.postpartum_days,
this.form.healing=data.healing,
this.form.uterus_place=data.uterus_place,
this.form.lochia_amount=data.lochia_amount,
this.form.lochia_color=data.lochia_color,
this.form.lochia_taste=data.lochia_taste,
this.form.chapped_nipple=data.chapped_nipple,
this.form.breast=data.breast,
this.form.milk_amount=data.milk_amount,
this.form.stool=data.stool,
this.form.pee=data.pee,
this.form.special_case=data.special_case,
this.form.advisory_date=data.advisory_date,
this.form.agent_sign=data.agent_sign.indexOf(this.get_host) != -1 ? data.agent_sign : this.get_host+data.agent_sign
this.form.shifts = data.shifts
if(nurser_name.length){
for(let item of nurser_name){
if(item.id == data.agent_id){
this.cfrText = item.user_name
}
}
}
this.form.agent_id = data.agent_id
this.showSignature = true
this.$vux.loading.hide()
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},

apiAddForm(){
let params = {
token: this.$cookie.get('token'),
member_id:this.$cookie.get('id'),
maternal_info_id: this.$route.query.id,
room:this.form.room,
delivery_type:this.form.delivery_type,
postpartum_days:this.form.postpartum_days,
healing:this.form.healing,
uterus_place:this.form.uterus_place,
lochia_amount:this.form.lochia_amount,
lochia_color:this.form.lochia_color,
lochia_taste:this.form.lochia_taste,
chapped_nipple:this.form.chapped_nipple,
breast:this.form.breast,
milk_amount:this.form.milk_amount,
stool:this.form.stool,
pee:this.form.pee,
special_case:this.form.special_case,
advisory_date:this.form.advisory_date,
agent_sign:this.form.agent_sign,
agent_id:this.form.agent_id,
shifts:this.form.shifts
}
console.info(params)
this.$vux.loading.show({
text: '正在加载'
})
Api.chritmasFormApi.addMatarnalHeathRecord(params).then ( res => {
console.info(res)
if(res.errcode == 200){
this.$vux.loading.hide()
this.$router.replace({
path:'/success',
query:{
id:this.$route.query.id,
form_id:this.$route.query.form_id,
tabVal:this.$route.query.tabVal,
name : 'christmas_form_one',
}
})
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},

apiUpdateForm(){
let params = {
id:this.$route.query.list_id,
token: this.$cookie.get('token'),
member_id:this.$cookie.get('id'),
maternal_info_id: this.$route.query.id,
room:this.form.room,
delivery_type:this.form.delivery_type,
postpartum_days:this.form.postpartum_days,
healing:this.form.healing,
uterus_place:this.form.uterus_place,
lochia_amount:this.form.lochia_amount,
lochia_color:this.form.lochia_color,
lochia_taste:this.form.lochia_taste,
chapped_nipple:this.form.chapped_nipple,
breast:this.form.breast,
milk_amount:this.form.milk_amount,
stool:this.form.stool,
pee:this.form.pee,
special_case:this.form.special_case,
advisory_date:this.form.advisory_date,
agent_sign:this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host,'') : this.form.agent_sign,
agent_id:this.form.agent_id,
shifts:this.form.shifts
}
console.info(params)
this.$vux.loading.show({
text: '正在加载'
})
Api.chritmasFormApi.updateMatarnalHeathRecord(params).then ( res => {
console.info(res)
if(res.errcode == 200){
this.$vux.loading.hide()
this.$router.replace({
path:'/success',
query:{
id:this.$route.query.id,
form_id:this.$route.query.form_id,
tabVal:this.$route.query.tabVal,
name : 'christmas_form_one',
}
})
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},
submitForm(){
let form = this.form
if(form.delivery_type == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择分娩方式',
})
return
}
if(form.advisory_date == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择健康咨询日期',
})
return
}
if(form.postpartum_days == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请输入产后天数',
})
return
}
if(form.healing == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择术口愈合情况',
})
return
}
if(form.uterus_place == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择宫底位置',
})
return
}
if(form.lochia_amount == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请输入恶露量',
})
return
}
if(form.lochia_color == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择恶露色',
})
return
}
if(form.lochia_taste == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择恶露味',
})
return
}
if(form.chapped_nipple == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择乳头皲裂',
})
return
}
if(form.breast == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择乳房情况',
})
return
}
if(form.milk_amount == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请输入乳汁量',
})
return
}
if(form.stool == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择大便',
})
return
}
if(form.pee == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择小便',
})
return
}
if(form.special_case == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请输入特殊情况',
})
return
}
if(form.shifts == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择班次',
})
return
}
if(form.agent_id == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请选择查房人',
})
return
}
if(form.agent_sign == ''){
this.$vux.toast.show({
type: 'cancel',
text: '请输入签名',
})
return
}
if(this.$route.query.list_id){
console.info("请求更新数据")
this.apiUpdateForm()
}else{
this.apiAddForm()
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/christmas_form_one.vue